var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_2429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.08569C10.3431 8.08569 9 9.42884 9 11.0857C9 12.7425 10.3431 14.0857 12 14.0857C13.6569 14.0857 15 12.7425 15 11.0857C15 9.42884 13.6569 8.08569 12 8.08569ZM10.5 11.0857C10.5 10.2573 11.1716 9.58569 12 9.58569C12.8284 9.58569 13.5 10.2573 13.5 11.0857C13.5 11.9141 12.8284 12.5857 12 12.5857C11.1716 12.5857 10.5 11.9141 10.5 11.0857Z",
    fill: "#BA1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5836 21.4595C11.5838 21.4596 11.584 21.4597 12 20.8357L11.5836 21.4595C11.8355 21.6274 12.1641 21.6277 12.416 21.4597L12 20.8357C12.416 21.4597 12.4158 21.4599 12.416 21.4597L12.4186 21.458L12.4236 21.4547L12.4408 21.443C12.4554 21.4331 12.4762 21.4189 12.5028 21.4004C12.5561 21.3635 12.6327 21.3098 12.7292 21.2401C12.9221 21.1007 13.1952 20.8974 13.5219 20.6372C14.174 20.118 15.0455 19.3678 15.9195 18.4453C17.6368 16.6325 19.5 14.0121 19.5 11.0857C19.5 9.09657 18.7098 7.18892 17.3033 5.78239C15.8968 4.37587 13.9891 3.58569 12 3.58569C10.0109 3.58569 8.10322 4.37587 6.6967 5.78239C5.29018 7.18892 4.5 9.09657 4.5 11.0857C4.5 14.0121 6.3632 16.6325 8.08054 18.4453C8.95454 19.3678 9.826 20.118 10.4781 20.6372C10.8048 20.8974 11.0779 21.1007 11.2708 21.2401C11.3673 21.3098 11.4439 21.3635 11.4972 21.4004C11.5238 21.4189 11.5446 21.4331 11.5592 21.443L11.5764 21.4547L11.5814 21.458L11.5836 21.4595ZM7.75736 6.84305C8.88258 5.71783 10.4087 5.08569 12 5.08569C13.5913 5.08569 15.1174 5.71783 16.2426 6.84305C17.3679 7.96827 18 9.49439 18 11.0857C18 13.4092 16.4882 15.6639 14.8305 17.4136C14.017 18.2723 13.201 18.9753 12.5875 19.4638C12.3592 19.6456 12.1597 19.7971 12 19.9151C11.8403 19.7971 11.6408 19.6456 11.4125 19.4638C10.799 18.9753 9.98296 18.2723 9.16946 17.4136C7.5118 15.6639 6 13.4092 6 11.0857C6 9.49439 6.63214 7.96827 7.75736 6.84305Z",
    fill: "#BA1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_2429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3.58569)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.551662a8fd1a6aab5a51032a45fb2144.svg";
export { ForwardRef as ReactComponent };